import React, { FC, SVGProps } from 'react';

const Email: FC<SVGProps<SVGSVGElement>> = props => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m4 4h16c1.1 0 2 0.9 2 2v12c0 1.1-0.9 2-2 2h-16c-1.1 0-2-0.9-2-2v-12c0-1.1 0.9-2 2-2z" clipRule="evenodd" fillRule="evenodd" stroke="#989AB0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    <path d="m22 6-10 7-10-7" stroke="#989AB0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
  </svg>
);

export default Email;
